import { graphql } from "@/lib/gql/__generated__";

export const OPTION_PMS_ITEM_FROM_DIRECT_UPDATE_COMMENT_FOR_OPTION_PMS_MUTATION = graphql(/* GraphQL */ `
	mutation OptionPmsItemFromDirectUpdateCommentFromOptionPms($input: OptionPmsItemFromDirectCommentInput!) {
		optionPmsItemFromDirectUpdateComment(input: $input) {
			userErrors
			optionPmsItem {
				id
				hotelID
				itemType
				reservationID
				uniqueID
				date
				guestName
				guestTel
				optionID
				subOptionID
				optionName
				subOptionName
				amount
				optionStartAt
				optionEndAt
				planName
				roomNum {
					adultNum
					kidsNum {
						age
						asCosleeping
					}
					uniqueRoomID
				}
				questions {
					question
					answer
				}
				memo
				canDelete
				isCanceled
			}
		}
	}
`);
